import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { AuthInjection } from '../../containers/authInjection';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { LoginPage } from './view';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
  easing: 'ease-out-back',
  duration: 1000,
  anchorPlacement: 'top-bottom',
});

const Login = (props) => {
  const { login, error, loading } = AuthInjection();
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: Cookies.get('rememberMe') || '',
      password: '',
      rememberMe: !!Cookies.get('rememberMe'),
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Por favor, insira seu usuário'),
      password: Yup.string().required('Por favor, insira sua senha'),
      rememberMe: Yup.boolean(),
    }),

    onSubmit: (values) => {
      login(values.username, values.password, values.rememberMe);
    },
  });

  return (
    <LoginPage
      validation={validation}
      error={error}
      loading={loading}
      toggleShowPassword={toggleShowPassword}
      showPassword={showPassword}
    />
  );
};

Login.propTypes = {
  history: PropTypes.object.isRequired,
};

Login.defaultProps = {
  history: {},
};

export default withRouter(Login);
